import React from 'react';
import '../styles/Servicios.css'

const services = [
  {
    id: 1,
    title: 'Sushi',
    description:
      'Viví el sushi de una forma única, con opción omakase y una propuesta personalizada',
  },
  {
    id: 2,
    title: 'Asado',
    description:
      'Los mejores cortes argentinos, con opciones vegetarianas, para una experiencia de asado única en tu evento.',
  },
  {
    id: 3,
    title: 'Finger food',
    description:
      'Menú con bocados fríos y calientes, perfecto para disfrutar sin formalidades.',
  },
  {
    id: 4,
    title: 'Barra',
    description:
      'Servicio de bebidas para complementar tu evento, con barra de autor y coctelería clásica.',
  },
  {
    id: 5,
    title: 'Picada',
    description:
      'Una picada de quesos y embutidos seleccionados, ideal para aportar carácter y distinción a tu evento.',
  },
  {
    id: 6,
    title: 'Coffe Break',
    description:
      'Coffee break ideal para pausas de calidad, con café, infusiones y opciones dulces y saladas. Perfecto para eventos corporativos y reuniones.',
  },
  {
    id: 6,
    title: 'Mesa Dulce',
    description:
      'Mesa dulce con variedad de postres y dulces, incluyendo pastelería y petit four, ideal para un cierre especial y elegante en tu evento.',
  },
  {
    id: 8,
    title: 'Meal Prep',
    description:
      'Armamos tu menú semanal y simplificamos tu día, con viandas listas para regenerar.',
  },
  

];

export default function Services() {
  return (
    <section id="services" className="services-section">
      <h2 className="services-title">Propuestas</h2>
      <div className="services-grid">
        {services.map((svc) => (
          <div key={svc.id} className="service-card">
            <h3 className="service-title">{svc.title}</h3>
            <p className="service-desc">{svc.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
